// extracted by mini-css-extract-plugin
export default {"container":"Welcome_container__BEijQ","conditions-container":"Welcome_conditions-container__0QjQ2"};